import styled from 'styled-components';
import { Typography } from 'antd';
import { useFormContext } from 'react-hook-form';

const { Text } = Typography;

interface FormWrapperProps {
  label: string;
  secondaryText?: string;
  secondaryTextIcon?: React.ReactNode;
  optionalText?: string;
  instructionText?: string;
  children?: React.ReactNode;
  name: string;
  wrapStyles?: React.CSSProperties;
}

const Wrapper = styled.div`
  display: grid;
  gap: 8px;
  white-space: pre-line;
`;

const LabelWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`;

const SecondaryTextWrapper = styled.div`
  display: flex;
  align-items: start;
  gap: 6px;
`;

export const FormWrapper = ({
  name,
  label,
  secondaryText,
  optionalText,
  instructionText,
  children,
  secondaryTextIcon,
  wrapStyles,
}: FormWrapperProps) => {
  const { formState } = useFormContext();
  const isArrayItem = name.includes('.');
  const [itemName, index] = name.split('.');

  return (
    <Wrapper style={wrapStyles}>
      {instructionText && <Text>{instructionText}</Text>}
      {label && (
        <LabelWrapper>
          <Text>{label}</Text>
          {optionalText && <Text type="secondary">{optionalText}</Text>}
        </LabelWrapper>
      )}
      {children}
      {secondaryText && (
        <SecondaryTextWrapper>
          {secondaryTextIcon}
          <Text>{secondaryText}</Text>
        </SecondaryTextWrapper>
      )}
      {!isArrayItem && formState.errors[name] && <Text type="danger">{formState.errors[name].message}</Text>}
      {isArrayItem && formState.errors[itemName] && formState.errors[itemName][index] && (
        <Text type="danger">{formState.errors[itemName][index].message}</Text>
      )}
    </Wrapper>
  );
};
